import React, { useState } from 'react';
import { Map, TreeDeciduous } from 'lucide-react';
import { Tree } from '../../types/tree';
import { GalleryMap } from './GalleryMap';
import { FilterPanel } from './FilterPanel';
import { BotanicalDivider } from '../shared/BotanicalDivider';
import './GalleryTab.css';

interface GalleryTabProps {
  trees: Tree[];
}

export const GalleryTab: React.FC<GalleryTabProps> = ({ trees }) => {
  const [selectedSpecies, setSelectedSpecies] = useState<string[]>([]);
  const [selectedConservation, setSelectedConservation] = useState<string[]>([]);
  const [selectedSizes, setSelectedSizes] = useState<string[]>([]);

  const handleReset = () => {
    setSelectedSpecies([]);
    setSelectedConservation([]);
    setSelectedSizes([]);
  };

  return (
    <section className="gallery-tab">
      <div className="gallery-tab__map-container">
        {/* Map - Full Screen */}
        <GalleryMap
          trees={trees}
          selectedSpecies={selectedSpecies}
          selectedConservation={selectedConservation}
          selectedSizes={selectedSizes}
        />

        {/* Floating Filter Panel - Right Side */}
        <div className="gallery-tab__floating-filters">
          <FilterPanel
            trees={trees}
            selectedSpecies={selectedSpecies}
            selectedConservation={selectedConservation}
            selectedSizes={selectedSizes}
            onSpeciesChange={setSelectedSpecies}
            onConservationChange={setSelectedConservation}
            onSizeChange={setSelectedSizes}
            onReset={handleReset}
          />
        </div>
      </div>
    </section>
  );
};

export default GalleryTab;
